import React, { useCallback, useEffect, useState } from "react";
import { Alert, Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api/api";
import authService from "../services/authService";
import NotificationService from "../services/NotificationService";
import NotificationComponent from "./NotificationComponent";
const UserDetails = ({
  isInstallable = false,
  isInstalled = false,
  requiresManualInstall = false,
  onInstall,
}) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [installMessage, setInstallMessage] = useState("");

  const { userId } = useParams();
  const navigate = useNavigate();
  const isTherapist = authService.isTherapist();
  const canShowNotifications = () => {
    const support = NotificationService.isPushNotificationSupported();
    return support.isSupported() && authService.isStaff();
  };
  const fetchUserDetails = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get("/users/me/");

      setUser(response.data);
      setLoading(false);
    } catch (error) {
      setError("Failed to load user details");
      setLoading(false);
      console.error(error);
    }
  }, []);
  useEffect(() => {
    fetchUserDetails();
  }, [fetchUserDetails]);

  const handleProfileInstall = async () => {
    if (typeof onInstall !== "function") return;

    const result = await onInstall();

    if (result?.outcome === "accepted") {
      setInstallMessage(
        "Now open Plasticise from the installed web app on your phone’s Home Screen."
      );
    }
  };

  const handleSignOut = async () => {
    try {
      await authService.logout();
    } catch (error) {
      console.error("Failed to sign out:", error);
      setError("Failed to sign out");
    }
  };

  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "50vh" }}
      >
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-4">
        <div className="text-center text-danger">{error}</div>
      </Container>
    );
  }

  return (
    <Container className="mt-4 mb-5 py-3">
      <Card className="mb-3">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <h2 className="mb-0">My Details</h2>
          <Button
            variant="primary"
            onClick={() => navigate(`/user/${userId}/edit`)}
          >
            Change Details
          </Button>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col sm={4} className="fw-bold">
              Name:
            </Col>
            <Col sm={8}>{`${user?.first_name} ${user?.last_name}`}</Col>
          </Row>

          <Row className="mb-3">
            <Col sm={4} className="fw-bold">
              Email:
            </Col>
            <Col sm={8}>{user?.email}</Col>
          </Row>

          <Row className="mb-3">
            <Col sm={4} className="fw-bold">
              Mobile:
            </Col>
            <Col sm={8}>{user?.mobile || "Not provided"}</Col>
          </Row>

          <Row className="mb-3">
            <Col sm={4} className="fw-bold">
              Date of Birth:
            </Col>
            <Col sm={8}>
              {user?.date_of_birth
                ? new Date(user.date_of_birth).toLocaleDateString()
                : "Not provided"}
            </Col>
          </Row>
          {!isTherapist && (
            <Row className="mb-3"></Row>
          )}
          {isTherapist && (
            <>
              <Row className="mb-3">
                <Col sm={4} className="fw-bold">
                  Discipline:
                </Col>
                <Col sm={8}>
                  {user?.therapist_profile?.discipline || "Not provided"}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={4} className="fw-bold">
                  Clinic:
                </Col>
                <Col sm={8}>
                  {user?.therapist_profile?.clinic_name || "Not provided"}
                </Col>
              </Row>
              <Row className="mb-3"></Row>
            </>
          )}

          {isTherapist === "true" && (
            <>
              <Row className="mb-3">
                <Col sm={4} className="fw-bold">
                  Clinic
                </Col>
                <Col sm={8}>
                  <div>{user?.clinic || "N/A"}</div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={4} className="fw-bold">
                  Discipline
                </Col>
                <Col sm={8}>
                  <div>{user?.discipline || "N/A"}</div>
                </Col>
              </Row>
            </>
          )}
        </Card.Body>
      </Card>
      {canShowNotifications && <NotificationComponent user={user} />}
      {!isInstalled && (isInstallable || requiresManualInstall) && (
        <Card className="mb-3">
          <Card.Body className="text-center">
            <Card.Text className="text-muted">
              Add Plasticise to this device for quicker access.
            </Card.Text>
            <Button variant="primary" onClick={handleProfileInstall}>
              Install Plasticise
            </Button>
          </Card.Body>
        </Card>
      )}
      {installMessage && (
        <Alert variant="success" className="mb-3 text-center" role="status">
          {installMessage}
        </Alert>
      )}
      <Row className="justify-content-center">
        <Col className="text-center">
          <a className="text-center mt-3 d-block mb-2" href="/terms?view=1">
            Legal & privacy
          </a>
          <div className="d-flex justify-content-center gap-3">
            <Button
              variant="outline-primary"
              href="mailto:admin@plasticise.app"
              className="mt-2"
            >
              Contact Support
            </Button>
            <Button variant="danger" onClick={handleSignOut} className="mt-2">
              Sign Out
            </Button>
          </div>
        </Col>
      </Row>{" "}
    </Container>
  );
};

export default UserDetails;
